import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { FlowObjectInstance } from '../models/flow-object.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlowObjectInstanceService extends BaseService {
    controllerRoute = 'FlowObjectInstance';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getById(id: string, version?: number): Promise<IBaseModel<FlowObjectInstance>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/${id}/${version || ''}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowObjectInstance>>(url));
    }

    public async update(data: FlowObjectInstance): Promise<IBaseModel<void>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}`;
        return await firstValueFrom(this.httpClient.put<IBaseModel<void>>(url, data));
    }

    public async executeTask(data: FlowObjectInstance): Promise<IBaseModel<void>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/ExecuteTask`;
        return await firstValueFrom(this.httpClient.put<IBaseModel<void>>(url, data));
    }

    public async enqueueTask(data: FlowObjectInstance): Promise<IBaseModel<FlowObjectInstance>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/EnqueueTask`;
        return await firstValueFrom(this.httpClient.put<IBaseModel<FlowObjectInstance>>(url, data));
    }

    public async bringMjolnir(id: string, inputData: any): Promise<IBaseModel<string>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/BringMjolnir`;
        return await firstValueFrom(this.httpClient.post<IBaseModel<string>>(url, { id: id, inputData: JSON.stringify(inputData) }));
    }
}
